<template>
    <fullscreen-drawer
        v-if="featureFlags['live-site-responsive-design']"
        :visible="visible"
        title="Filter"
        @close="handleClose"
    >
        <div slot="header-button" class="clear-all-button" @click="clearFilters">Clear all</div>
        <div class="quick-date-buttons g-mb-3">
            <g-button
                v-for="(quickDateFilter, index) in quickDateFilters"
                :key="index"
                :class="`g-mr-5 g-mb-5 ${index === selectedQuickFilterIndex ? 'quick-filter-button--selected' : ''}`"
                shape="round"
                theme="live"
                @click="() => handleQuickDateFilter(index)"
            >
                <g-typography class="quick-filter-button__text" font-weight="semibold">{{
                        quickDateFilter.title
                    }}</g-typography>
            </g-button>
        </div>
        <g-form>
            <g-form-item class="g-mb-3" label="Start Date">
                <g-date-picker
                    v-model="startDate"
                    class="date-picker"
                    format="MM/DD/YYYY"
                    size="default"
                    placeholder=""
                    @change="unsetSelectedQuickFilterIndex"
                />
                <input
                    v-model="startDate"
                    type="date"
                    class="date-picker-native g-px-3"
                    pattern="\d{1,2}/\d{1,2}/\d{4}"
                    @change="unsetSelectedQuickFilterIndex"
                />
            </g-form-item>
            <g-form-item label="End Date">
                <g-date-picker
                    v-model="endDate"
                    class="date-picker"
                    format="MM/DD/YYYY"
                    size="default"
                    placeholder=""
                    @change="unsetSelectedQuickFilterIndex"
                />
                <input
                    v-model="endDate"
                    type="date"
                    class="date-picker-native g-px-3"
                    pattern="\d{1,2}/\d{1,2}/\d{4}"
                    @change="unsetSelectedQuickFilterIndex"
                />

            </g-form-item>
            <g-button
                class="submit-button"
                theme="live"
                shape="round"
                type="primary"
                size="large"
                @click="onSubmit"
            >
                Apply
            </g-button>
        </g-form>
    </fullscreen-drawer>

    <g-drawer v-else :visible="visible" height="100%" get-container="#app" placement="bottom" @close="handleClose">
        <div class="g-mb-5">
            <g-typography tag="span" size="h2" font-weight="semibold" class="g-mb-6">Filter</g-typography>
            <g-button class="clear-all-button clear-all-button__old g-mr-5" @click="clearFilters">Clear all</g-button>
        </div>
        <div class="quick-date-buttons g-mb-3">
            <g-button
                v-for="(quickDateFilter, index) in quickDateFilters"
                :key="index"
                :class="`g-mr-5 g-mb-5 ${index === selectedQuickFilterIndex ? 'quick-filter-button--selected' : ''}`"
                shape="round"
                theme="live"
                @click="() => handleQuickDateFilter(index)"
            >
                <g-typography class="quick-filter-button__text" font-weight="semibold">{{
                    quickDateFilter.title
                }}</g-typography>
            </g-button>
        </div>
        <g-form>
            <g-form-item class="g-mb-3" label="Start Date">
                <g-date-picker
                    v-model="startDate"
                    class="date-picker"
                    format="MM/DD/YYYY"
                    size="default"
                    placeholder=""
                    @change="unsetSelectedQuickFilterIndex"
                />
                <input
                    v-model="startDate"
                    type="date"
                    class="date-picker-native g-px-3"
                    pattern="\d{1,2}/\d{1,2}/\d{4}"
                    @change="unsetSelectedQuickFilterIndex"
                />
            </g-form-item>
            <g-form-item label="End Date">
                <g-date-picker
                    v-model="endDate"
                    class="date-picker"
                    format="MM/DD/YYYY"
                    size="default"
                    placeholder=""
                    @change="unsetSelectedQuickFilterIndex"
                />
                <input
                    v-model="endDate"
                    type="date"
                    class="date-picker-native g-px-3"
                    pattern="\d{1,2}/\d{1,2}/\d{4}"
                    @change="unsetSelectedQuickFilterIndex"
                />

            </g-form-item>
            <g-button
                class="submit-button"
                theme="live"
                shape="round"
                type="primary"
                size="large"
                @click="onSubmit"
            >
                Apply
            </g-button>
        </g-form>
    </g-drawer>
</template>

<script>
    import { ref } from 'vue-demi';
    import moment from 'moment';
    import { message } from '@grininc/grin-ui';
    import {useContactStore, useFeatureFlagsStore} from '../../../../../stores';
    import useEventTracking from '../../../../composables/use-event-tracking';
    import {
        EVENT_NAME_DATE_FILTER_APPLIED
    } from '../../../../../app-v2/constants/analytics-events';
    import FullscreenDrawer from "../../../../../app-v2/components/library/FullscreenDrawer";

    export default {
        name: 'PaymentsAndConversionsFilterDrawer',
        components: {FullscreenDrawer},
        props: {
            visible: {
                type: Boolean,
                default: false
            },
        },

        setup(props, context) {
            const contact = useContactStore().data;
            const featureFlags = useFeatureFlagsStore().data;

            const startDate = ref(null);
            const endDate = ref(null);
            const selectedQuickFilterIndex = ref(0);

            const events = useEventTracking();

            const quickDateFilters = [
                {
                    title: 'All Time',
                    start: null,
                    end: null
                },
                {
                    title: 'Last Day',
                    start: moment().subtract(1, 'days').format('YYYY-MM-DD'),
                    end: moment().format('YYYY-MM-DD')
                },
                {
                    title: 'Last Week',
                    start: moment().subtract(1, 'weeks').format('YYYY-MM-DD'),
                    end: moment().format('YYYY-MM-DD')
                },
                {
                    title: 'Last Month',
                    start: moment().subtract(1, 'months').format('YYYY-MM-DD'),
                    end: moment().format('YYYY-MM-DD')
                }
            ];

            function unsetSelectedQuickFilterIndex() {
                if (selectedQuickFilterIndex.value) {
                    selectedQuickFilterIndex.value = null;
                }
            }

            function handleClose() {
                context.emit('close');
            }

            function handleQuickDateFilter(index) {
                selectedQuickFilterIndex.value = index;
                const data = quickDateFilters[index];
                startDate.value = data.start;
                endDate.value = data.end;
            }

            function clearFilters() {
                startDate.value = null;
                endDate.value = null;
                selectedQuickFilterIndex.value = 0;
            }

            function validateFilters() {
                if (moment(startDate.value) > moment(endDate.value)) {
                    message.error('Invalid dates selected, end date must be greater than or equal to start date.');
                    return false;
                }

                return true;
            }

            function onSubmit() {
                if (!validateFilters()) {
                    return;
                }

                context.emit(
                    'set-filter-button-text-override',
                    selectedQuickFilterIndex.value ? quickDateFilters[selectedQuickFilterIndex.value].title : ''
                );

                context.emit('apply-filters', {
                    startDate: startDate.value ? moment(startDate.value).format() : null,
                    endDate: endDate.value ? moment(endDate.value).endOf('day').format() : null
                });

                context.emit('close');

                events.trackEvent(EVENT_NAME_DATE_FILTER_APPLIED, getDateFilterEventPayload());
            }

            const getDateFilterEventPayload = () => {
                return {
                    dl_contact_id: contact.id,
                    date_filter_type: {
                        all_time: {
                            start: startDate.value,
                            end: endDate.value
                        },
                        last_day: {
                            start: quickDateFilters[1].start,
                            end: quickDateFilters[1].end
                        },
                        last_week: {
                            start: quickDateFilters[2].start,
                            end: quickDateFilters[2].end
                        },
                        last_month:  {
                            start:  quickDateFilters[3].start,
                            end:  quickDateFilters[3].end
                        },
                        custom: {
                            start: startDate.value,
                            end: endDate.value
                        }
                    }
                };
            };

            return {
                //functions
                handleClose,
                unsetSelectedQuickFilterIndex,
                handleQuickDateFilter,
                onSubmit,
                clearFilters,

                //date state
                startDate,
                endDate,

                quickDateFilters,
                selectedQuickFilterIndex,
                featureFlags
            };
        }
    };
</script>

<style lang="scss" scoped>
    .submit-button {
        width: 100%;
    }
    @media (max-width: $g-screen-size-md) {
        .date-picker {
            display: none;
        }
    }
    @media (min-width: $g-screen-size-md) {
        .date-picker-native {
            display: none;
        }
    }
    .date-picker {
        width: 100%;
    }

    .date-picker-native {
        width: 100%;
        height: 32px;
        border: 1px solid $g-color-grey-4;
        border-radius: 4px;
    }

    .quick-filter-button--selected {
        border-color: #5acbf1 !important;
        .quick-filter-button__text {
            color: #5acbf1 !important;
        }
    }

    .clear-all-button {
        border: none;
        color: #5acbf1 !important;
        float: right;
        box-shadow: none;
    }

    //TODO: remove class when removing old non-respoonsive styles
    .clear-all-button__old {
        margin-top: -0.85em;
    }
</style>
